import PropTypes from "prop-types";
import PremierButton from "../../components/PremierButton/index.jsx";
import style from "./styles";
import trackAddToBag from "../../utils/trackAddToBag";

const PremierAddToBagButton = ({
  addPremierSubscription,
  buttonText,
  buttonTextAdded,
  highReturner,
  premierPrice,
  premierSubscriptionAdded,
  subscriptionId,
}) =>
  !premierSubscriptionAdded ? (
    <PremierButton
      style={style}
      onClick={() => {
        addPremierSubscription(subscriptionId);
        trackAddToBag(premierPrice);
      }}
      buttonText={buttonText}
      disabled={highReturner}
    />
  ) : (
    <PremierButton
      style={style}
      className={style.PremierSubscriptionAdded}
      buttonText={buttonTextAdded}
    />
  );

PremierAddToBagButton.propTypes = {
  addPremierSubscription: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonTextAdded: PropTypes.string,
  highReturner: PropTypes.bool.isRequired,
  premierPrice: PropTypes.string.isRequired,
  premierSubscriptionAdded: PropTypes.bool.isRequired,
  subscriptionId: PropTypes.number.isRequired,
};

export default PremierAddToBagButton;
